import { Container, Box, Grid } from '@material-ui/core'
import i18n from '../i18n/i18n'
import { NewTrend } from './NewTrend'
import { NewNews } from './NewNews'
import { NewCompanySpotlight } from './NewCompanySpotlight'
import { NewJobDay } from './NewJobDay'
import { SubscribeMe } from './subscribe_me'
import { HomeFiltering } from './Filtering'
import { FetchedMain } from './Fetchedmain'
import { ActiveCompanies } from './ActiveCompanies'
import { Technologies } from './Technologies'

export const AccueilGlobal = (initialData) => {
  return (
    <Container>
      <Box mt={8}>
        <HomeFiltering />
      </Box>

      <Box mt={8}>
        <FetchedMain initialData={initialData} source="homepage" />
      </Box>

      <ActiveCompanies />
      
      <Technologies />

      <Box mt={8}>
        <NewNews countryCode={initialData.isLocal} />
      </Box>

      <Box mt={8}>
        <SubscribeMe
          condition={(auth) => auth.loggedIn()}
          h1={i18n.t('subscribe_me.title')}
          subTitle={i18n.t('subscribe_me.subtitle')}
          subText={i18n.t('subscribe_me.subtext')}
        />
      </Box>
    </Container>
  )
}

export default AccueilGlobal
